import { rollbar } from "./rollbar"

export const logger = {
  error(error: unknown) {
    if (import.meta.env.DEV) {
      console.error(error)
    }
    rollbar.error(error as any)
  },
}
